import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "@mui/material";
import { loginRequest } from "../config/authConfig";

export const SignInButton = () => {
  const { instance } = useMsal();

  const handleLogin = (loginType: string) => {
    if (loginType === "popup") {
      instance.loginPopup(loginRequest)
	  	.then((response) => {
			instance.setActiveAccount(response.account);
		})
		.catch((e) => {			
       		console.log(e);
      });
    } else if (loginType === "redirect") {
      instance.loginRedirect(loginRequest).catch((e) => {
        console.log(e);
      });
    }
  };
  return (
    <>
      <Button variant="contained" onClick={() => handleLogin("popup")}>
        Sign in
      </Button>
    </>
  );
};